import { mainThemeColors, mainThemeColorsNBD } from '@volkswagen-onehub/tokens';

const isNewBrandDesign = (): boolean => {
	return true;
};

export const COLOR = {
	WHITE_25: 'rgba(255, 255, 255, 0.25)',
	WHITE_50: 'rgba(255, 255, 255, 0.5)',
	WHITE_75: 'rgba(255, 255, 255, 0.75)',
	WHITE: 'rgb(255, 255, 255)',
	MEDIUM_WHITE: 'rgb(223, 228, 232)',
	MEDIUM_GREY: 'rgb(56, 63, 81)',
	DARK_GREY: 'rgb(27, 34, 54)',
	DARK_GREY_70: 'rgba(27, 34, 54, 0.7)',
	BLACK: 'rgb(0, 0, 0)',
	BLACK_25: 'rgba(0, 0, 0, 0.25)',
	BLACK_50: 'rgba(0, 0, 0, 0.5)',
	BLACK_75: 'rgba(0, 0, 0, 0.75)',
	STROKE: 'rgba(0, 0, 0, 0.03)',
};

export const GRADIENT = {
	CONTENT: isNewBrandDesign()
		? 'linear-gradient(180deg, transparent 0%, rgba(53, 14, 14, 0.05) 50%,rgba(0, 0, 0, 0.05) 100%)'
		: 'linear-gradient(rgb(246, 246, 246) 0%, rgb(223, 228, 232) 100%)',
	LAYER: isNewBrandDesign()
		? `linear-gradient(90deg, ${COLOR.MEDIUM_GREY} 0%, ${COLOR.DARK_GREY} 50%, ${COLOR.MEDIUM_GREY} 100%)`
		: 'linear-gradient(270deg, rgb(0, 67, 122) 0%, rgb(0, 30, 80) 100%)',
	TRANSPARENT: `linear-gradient(0deg, transparent, ${COLOR.WHITE} 10%, ${COLOR.WHITE} 90%, transparent)`,
};

export const COLOR_TOKEN = isNewBrandDesign() ? mainThemeColorsNBD : mainThemeColors;
